// extracted by mini-css-extract-plugin
export default {"container":"czt2Bke07yxzWNJhU88d","title":"EbJoyb5iqL9oPzxny0to","valueBox":"TNkjkVdnGRGA86mvonUw"};